import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSave, FiVideo, FiType, FiPower } = FiIcons;

export default function StreamSettings({ settings, onUpdate }) {
  const [formData, setFormData] = useState({
    stream_url: '',
    title: '',
    is_active: true
  });
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState({ error: '', success: '' });

  useEffect(() => {
    if (settings) {
      setFormData({
        stream_url: settings.stream_url || '',
        title: settings.title || '',
        is_active: settings.is_active ?? true
      });
    }
  }, [settings]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus({ error: '', success: '' });

    try {
      await onUpdate(formData);
      setStatus({ error: '', success: 'Configuración guardada correctamente.' });
    } catch (err) {
      setStatus({ error: 'Error al guardar la configuración.', success: '' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="overflow-hidden rounded-2xl border border-white/10 bg-[#111]">
      <div className="border-b border-white/10 px-4 py-4 sm:px-6">
        <h2 className="font-semibold text-white">Configuración de Transmisión</h2>
        <p className="mt-1 text-xs text-gray-500">
          Gestiona la señal de video y el estado global de la plataforma.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
        <label className="block">
          <span className="mb-2 block text-sm font-medium text-gray-300">
            Título del Evento
          </span>
          <div className="flex items-center rounded-xl border border-white/10 bg-white/5 px-3 focus-within:border-red-500 focus-within:bg-white/10 transition-colors">
            <SafeIcon icon={FiType} className="text-gray-500" />
            <input
              type="text"
              required
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="w-full bg-transparent px-3 py-3 text-sm text-white outline-none"
              placeholder="Ej. Gran Derby de Gallos"
            />
          </div>
        </label>

        <label className="block">
          <span className="mb-2 block text-sm font-medium text-gray-300">
            URL del Streaming (M3U8 / HLS)
          </span>
          <div className="flex items-center rounded-xl border border-white/10 bg-white/5 px-3 focus-within:border-red-500 focus-within:bg-white/10 transition-colors">
            <SafeIcon icon={FiVideo} className="text-gray-500" />
            <input
              type="url"
              required
              value={formData.stream_url}
              onChange={(e) => setFormData({ ...formData, stream_url: e.target.value })}
              className="w-full bg-transparent px-3 py-3 text-sm text-white outline-none"
              placeholder="https://..."
            />
          </div>
          <p className="mt-1.5 text-xs text-gray-500">
            Asegúrate de que sea una URL válida terminada en .m3u8
          </p>
        </label>

        <div className="flex items-center justify-between rounded-xl border border-white/10 bg-white/5 p-4">
          <div>
            <h3 className="text-sm font-medium text-white">Estado de la transmisión</h3>
            <p className="text-xs text-gray-500 mt-1">Activa o pausa la señal de video para los espectadores.</p>
          </div>
          <button
            type="button"
            onClick={() => setFormData({ ...formData, is_active: !formData.is_active })}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              formData.is_active ? 'bg-red-600' : 'bg-gray-600'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                formData.is_active ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>

        {status.error && (
          <p className="rounded-lg bg-red-500/10 p-3 text-sm text-red-400 border border-red-500/20">
            {status.error}
          </p>
        )}
        {status.success && (
          <p className="rounded-lg bg-green-500/10 p-3 text-sm text-green-400 border border-green-500/20">
            {status.success}
          </p>
        )}

        <button
          type="submit"
          disabled={saving}
          className="flex w-full items-center justify-center gap-2 rounded-xl bg-red-600 py-3.5 text-sm font-bold text-white transition-colors hover:bg-red-700 disabled:opacity-50 sm:w-auto sm:px-8"
        >
          <SafeIcon icon={FiSave} />
          {saving ? 'Guardando...' : 'Guardar Cambios'}
        </button>
      </form>
    </section>
  );
}